import { Component } from '@angular/core';
import { NavController, NavParams ,ViewController} from 'ionic-angular';
import {IMAGES_BASE_URL} from '../../providers/config';
import {CartManager} from "../../providers/cart-manager";
import {Events} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-barcode-modal',
  templateUrl: 'barcode-modal.html',
})
export class BarcodeModalPage {
	baseImageUrl = IMAGES_BASE_URL;
	product:any ={
		name:"Dummy Name"
	};

  constructor(public navCtrl: NavController,
  	public navParams: NavParams,
  	private viewController:ViewController,
  	private cartManager:CartManager,
  	private events:Events,
    private gVLogger: GVLogger
  	) {
    this.product = this.navParams.get('product');
  }

  ionViewDidLoad() {

  }

  dismiss(){
  	this.viewController.dismiss();
  }

discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }

 discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  addProductToCart(item){
  this.cartManager.addProductToCart(item);
  this.events.publish("cartUpdated");
}

removeProductFromCart(product){
  this.cartManager.removeOneNew(product);
  this.events.publish("cartUpdated");
}

updateProductInCart(product){

  if(String(product.quantity) !=""){
    if(String(product.quantity).match(/^\d+$/)){
      this.cartManager.updateCartNew(product);
    }else{
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      this.cartManager.updateCartNew(product);
    }
  }else{

      product.quantity = Number(product.minOrder);
      this.cartManager.updateCartNew(product);
  }

  this.events.publish("cartUpdated");

  }




}



// WEBPACK FOOTER //
// ./src/pages/barcode-modal/barcode-modal.ts